import Steps from 'modals/ModalController/Steps';
import Program from 'models/Program';
import React, { useState } from 'react';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

interface CreateProgramV2Props {
  program: Program;
  onUpdateProgram: (updatedProgram: Program) => void;
  onClose: (program: Program | null) => void;
}

const CreateProgramV2: React.FC<CreateProgramV2Props> = ({ onClose }) => {
  const [program, setProgram] = useState<Program>(new Program());

  const onUpdateProgram = (updatedProgram: Program) => {
    setProgram(updatedProgram);
  };

  const closeModal = (updatedProgram: Program | null) => {
    onClose(updatedProgram || program);
  };

  return (
    <div className="create-program-v2">
      <Steps>
        <Steps.Item>
          <Step1 program={program} onUpdateProgram={onUpdateProgram} onClose={closeModal} />
        </Steps.Item>
        <Steps.Item>
          <Step2 program={program} onUpdateProgram={onUpdateProgram} onClose={closeModal} />
        </Steps.Item>
        <Steps.Item>
          <Step3 program={program} onClose={closeModal} />
        </Steps.Item>
      </Steps>
    </div>
  );
};

export default CreateProgramV2;
